import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "headerBox",
    class: {
      fixed: _vm.isFixed
    }
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('em', [!_vm.isShow ? _c('span', [_vm._v("欢迎进入驰腾商城")]) : _vm._e(), _vm.isShow ? _c('div', {
    staticClass: "to-back",
    on: {
      "click": _vm.goback
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("返回")]), _vm._m(0)]) : _vm._e(), _vm.isShow ? _c('div', {
    staticClass: "reload",
    on: {
      "click": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("刷新")]), _vm._m(1)]) : _vm._e(), _vm._l(_vm.indexServiceStr, function (item, index) {
    return _c('b', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item,
        expression: "item"
      }],
      key: index
    }, [_vm._v(_vm._s(item))]);
  })], 2), _c('p', [!_vm.isLogin ? _c('router-link', {
    staticClass: "line",
    attrs: {
      "tag": "span",
      "to": "/login"
    }
  }, [_vm._v("登录/注册")]) : _c('el-dropdown', {
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('span', {
    staticClass: "nickname"
  }, [_c('b', {
    staticClass: "text-line"
  }, [_vm._v(_vm._s(_vm.userinfor.userinfolist.nickName))]), _c('i')]), _c('el-dropdown-menu', {
    staticClass: "usercenter",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "user"
    }
  }, [_vm._v("个人中心")]), _c('el-dropdown-item', {
    attrs: {
      "command": "login"
    }
  }, [_vm._v("退出登录")])], 1)], 1), _c('span', {
    staticClass: "text",
    on: {
      "click": _vm.goOrderList
    }
  }, [_vm._v("我的订单")]), _vm.isLogin ? _c('span', {
    staticClass: "text message",
    on: {
      "click": _vm.goMessage
    }
  }, [_vm._v("我的消息 ")]) : _vm._e()], 1)])]), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-img"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/logo.png")
    }
  })]), _vm.$route.path == '/' ? _c('div', {
    staticClass: "equipment",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handClick.apply(null, arguments);
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.printerModelInfor.printerModel ? _vm.printerModelInfor.printerModel.imgPath : require('../assets/images/bz.png'),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "equipment-text"
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.printerModelInfor.printerModel ? _vm.printerModelInfor.printerModel.printerModel : '全部机型'))]), _vm._m(2)])]) : _vm._e()], 1), _c('div', {
    staticClass: "search-cont"
  }, [_c('div', {
    staticClass: "search-inp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.value,
      expression: "value"
    }],
    attrs: {
      "type": "text",
      "placeholder": "搜索商品名称、耗材尺寸",
      "maxlength": "40"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search.apply(null, arguments);
      },
      "focus": _vm.openShow,
      "blur": _vm.closeShowHistory,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.value = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "search-btn",
    on: {
      "click": _vm.search
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  })])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHistory && _vm.searchList.length > 0,
      expression: "showHistory && searchList.length > 0"
    }],
    staticClass: "search-record"
  }, [_vm.searchList.length === 0 ? _c('div', {
    staticClass: "no-record"
  }, [_vm._v("没有最近的搜索")]) : _c('ul', _vm._l(_vm.searchList, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
          return _vm.selectSearch(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.keyword))]), _c('i', {
      staticClass: "iconfont icondelete",
      on: {
        "mousedown": function mousedown($event) {
          $event.stopPropagation();
          return _vm.deleteSearch(item.id);
        }
      }
    })]);
  }), 0)]), _c('div', {
    staticClass: "servicewords"
  }, _vm._l(_vm.hotWordsList, function (item) {
    return _c('span', {
      key: item.id,
      on: {
        "click": function click($event) {
          return _vm.hotwordsSearch(item);
        }
      }
    }, [_vm._v(_vm._s(item.keyword))]);
  }), 0), _c('router-link', {
    staticClass: "shopping",
    attrs: {
      "to": "/card",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "iconfont icongouwuche"
  }), this.cardstate.cardnumber !== 0 ? _c('em', [_vm._v(_vm._s(this.cardstate.cardnumber))]) : _vm._e(), _c('span', [_vm._v("我的购物车")])])], 1)])])]), _c('input', {
    ref: "hiddenInput",
    staticStyle: {
      "position": "absolute",
      "width": "0px",
      "height": "0px",
      "z-index": "-1"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "focus": _vm.hiddenFocus,
      "blur": _vm.hiddenBlur
    }
  }), ['/', '/classify', '/details', '/card'].includes(_vm.$route.path) && _vm.whiteState.whiteStauts.isExchangeShow2 ? _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tipsLeft"
  }, [_vm._m(3), _c('div', {
    staticClass: "red"
  }, [_vm._v("每满1元赠送1天软件VIP会员 ")]), _vm.whiteState.whiteStauts.exchangeDay > 0 ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm._v(" ，完成购物车结算，可赠送软件VIP会员 "), _c('div', {
    staticStyle: {
      "color": "#FF0000"
    }
  }, [_vm._v(" " + _vm._s(_vm.whiteState.whiteStauts.exchangeDay) + " ")]), _vm._v(" 天 "), _vm.$route.path !== '/card' ? _c('div', {
    staticClass: "nav",
    on: {
      "click": _vm.handClose
    }
  }, [_vm._v(" 去结算> ")]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "tipsRight",
    on: {
      "click": _vm.handTips
    }
  }, [_vm._v(" 查看规则 > ")])])])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "i-box"
  }, [_c('i', {
    staticClass: "iconfont iconxingzhuang"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "i-box"
  }, [_c('i', {
    staticClass: "iconfont iconbianzu51"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#808080",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("切换")]), _c('span', [_c('img', {
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": require("../assets/images/qh.png"),
      "alt": ""
    }
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "boxImg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/vip.png"),
      "alt": ""
    }
  }), _vm._v(" 买原装耗材， ")]);
}];
export { render, staticRenderFns };